

export class Query {
	siteId = '';
	search = '';
	sortBy = 'name';
	sortDesc = false;
}